/* eslint-disable import/no-extraneous-dependencies */
// ============================================================================
// objectLoaderThree.ts
// ============================================================================

import {
  Group as ThreeGroup,
  Mesh as ThreeMesh,
  Object3D as ThreeObject3D,
} from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export type ObjectPartThree = {
  groupID: number;
  optionID: number;
  root: ThreeGroup;
};

const gltfLoader = new GLTFLoader();

export async function ObjectLoaderThree(
  dirPath: string,
  fileName: string,
  groupID: number,
  optionID: number,
): Promise<ObjectPartThree> {
  const normalizedDirPath = dirPath.replace(/\\/g, '/').replace(/\/$/, '');
  const normalizedFileName = fileName.replace(/\\/g, '/').replace(/^\//, '');
  const url = normalizedDirPath.length > 0
    ? `${normalizedDirPath}/${normalizedFileName}`
    : normalizedFileName;

  const gltf = await gltfLoader.loadAsync(url);

  const root = new ThreeGroup();
  root.name = `object_${groupID}_${optionID}`;
  root.add(gltf.scene);

  root.traverse((child: ThreeObject3D) => {
    const mesh = child as ThreeMesh;

    if (!mesh.isMesh) return;

    mesh.castShadow = true;
    mesh.receiveShadow = true;

    // Keep frustum culling on by default. If any shoe/model parts disappear incorrectly,
    // this can be changed per mesh here:
    // mesh.frustumCulled = false;
  });

  return {
    groupID,
    optionID,
    root,
  };
}
